import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ThowColumLayoutLogin from "../../layouts/ThowColumLayoutLogin";
import landingIcon from "../../images/svg/landingIcon.svg";
import companyIcon from "../../images/svg/companyIcon.svg";
import Input from "../../components/Input";
import Button from "../../components/Button";

import api from "../../services/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Landing = () => {
  const navigate = useNavigate();

  const [mail, setMail] = useState("");
  const [password, setPassword] = useState("");
  const [mailError, setMailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(true);

  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

  const validateInputs = () => {
    let isValid = true;

    if (!validateEmail(mail)) {
      setMailError("Email inválido");
      isValid = false;
    } else {
      setMailError("");
    }

    if (password.length < 8) {
      setPasswordError("Senha deve conter no mínimo 8 caracteres");
      isValid = false;
    } else {
      setPasswordError("");
    }

    setBtnDisabled(!isValid);
    return isValid;
  };

  const handleLogin = async () => {
    if (!validateInputs()) return;

    try {
      const response = await api.post("sessions", { mail, password });

      if (response.status === 200) {
        const { user, token } = response.data;
        localStorage.setItem("@USER_NAME", user.name);
        localStorage.setItem("@USER_MAIL", user.mail);
        localStorage.setItem("@USER_TOKEN", token);
        localStorage.setItem("@USER_PERMISSION", user.permission);
        localStorage.setItem("@USER_PICTURE", user.picture || false);

        navigate("/dashboard");
      } else {
        throw new Error("Invalid credentials");
      }
    } catch (error) {
      toast.error("Email ou senha inválidos!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }
  };

  useEffect(() => {
    validateInputs();
  }, [mail, password]);

  const styles = {
    image: {
      height: "100vh",
    },
    containerColum2: {
      paddingTop: "7.5rem",
    },
  };

  return (
    <ThowColumLayoutLogin
      page="Landing"
      colum1={
        <div>
          <img src={landingIcon} alt="Landing Icon" style={styles.image} />
        </div>
      }
      colum2={
        <div style={styles.containerColum2}>
          <ToastContainer />
          <img src={companyIcon} alt="Company Icon" />
          <h2 className="textPrimaryLanding">Dados de acesso</h2>

          <Input
            name="E-mail"
            error={mailError}
            onChange={(e) => setMail(e.target.value)}
            placeholder="Insira seu e-mail"
            type="text"
          />
          <Input
            name="Senha"
            error={passwordError}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Insira sua senha"
            type="password"
          />

          <Button
            width="416px"
            height="48px"
            background="#123164"
            borderRadius="60px"
            marginTop="3rem"
            name="Entrar"
            border="none"
            disabled={btnDisabled}
            onClick={handleLogin}
          />
        </div>
      }
    />
  );
};

export default Landing;
